

























































import { Vue, Component, Prop } from 'vue-property-decorator';

import ModalViewPDF from '@/pantallas/SucursalVirtual/Capacitaciones/ModalViewPDF.vue';
import { OpcionesApi } from './models/Capacitaciones.model';

@Component({
  components: { ModalViewPDF },
})
export default class CardsCategoria extends Vue {
  @Prop({ required: true, default: [] }) dataOption!: OpcionesApi[];
  @Prop({ required: true, default: 0 }) element: number;

  dialog: boolean = false;
  url: string = '';
  title: string = '';
  filter: string = '';
  dataFilter: OpcionesApi[] = [];

  mounted() {
    this.dataFilter = [...this.dataOption];
  }

  handleFilter() {
    if (this.filter) {
      const filter = this.filter.toLowerCase().trim();
      this.dataFilter = this.dataOption.filter(
        item =>
          item.titulo
            .toLowerCase()
            .trim()
            .includes(filter) ||
          item.subtitulo
            .toLowerCase()
            .trim()
            .includes(filter)
      );
      return;
    }
    this.dataFilter = [...this.dataOption];
  }

  toggleUrl(url: string, optionModal: boolean = true, title: string = '') {
    if (optionModal) {
      this.url = `${process.env.VUE_APP_SERVICIO_MS}track/view?url=${btoa(
        url
      )}`;
      this.title = title;
      this.dialog = !this.dialog;
    } else {
      this.url = `${process.env.VUE_APP_SERVICIO_MS}track/view?url=${btoa(
        url
      )}&download=SI`;
    }
  }
}
